/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2019. All Rights Reserved.
 #*
 #*===================================================================
 */
import { Action, createReducer, on } from '@ngrx/store';

import { ApiUtilsActions } from '@store/actions';
export const API_UTILS_FEATURE_KEY = 'apiUtils';

export interface APIUtilsState {
  usaStates: {
    data: any[];
    loaded: boolean;
    loading: boolean;
  };
}

const initialState: APIUtilsState = {
  usaStates: {
    data: [],
    loaded: false,
    loading: false,
  },
};

const reducer = createReducer(
  initialState,

  // Usa States
  on(ApiUtilsActions.loadUsaStates, (state) => ({
    ...state,
    usaStates: {
      loading: true,
      loaded: false,
      data: [],
    },
  })),
  on(ApiUtilsActions.loadUsaStatesSuccess, (state, { data }) => ({
    ...state,
    usaStates: {
      loading: false,
      loaded: true,
      data,
    },
  })),
  on(ApiUtilsActions.loadUsaStatesFailure, (state) => ({
    ...state,
    usaStates: {
      loading: false,
      loaded: false,
      data: [],
    },
  }))
);

export function apiUtilsReducer(state: APIUtilsState | undefined, action: Action): APIUtilsState {
  return reducer(state, action);
}
